module.exports = __webpack_public_path__ + "media/images/icons/material/chat-2bd71d5f63dccee6979c36790e87d956.svg";